(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentAssessControllers')
        .controller('RiskSelfAssessmentAssessWelcomeController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'govProcess', 'riskSelfAssessmentAssessService', 'authenticatedAssessorID', 'assessmentQuestions'];

    function Controller($scope, $state, $stateParams, govProcess, riskSelfAssessmentAssessService, authenticatedAssessorID, assessmentQuestions) {
        $scope.govProcess = govProcess;

        $scope.goToAssessments = function () {
            if (assessmentQuestions && assessmentQuestions.RiskAssessmentQuestions && assessmentQuestions.RiskAssessmentQuestions.length) {
                // Go to Preliminary Questions
                $state.go('riskSelfAssessmentAssess.preliminaryQuestions');
            } else {
                // Go to first Risk
                riskSelfAssessmentAssessService
                    .getRisksToAssess(authenticatedAssessorID)
                    .then(function (risksToAssess) {
                        if (!_.isArray(risksToAssess) || _.size(risksToAssess) < 1) return;
                        $state.go('riskSelfAssessmentAssess.assessor.riskToAssess', { RiskID: risksToAssess[0].Risk.RiskID });
                    });
            }
        };
    }
})();
